// side effect: store configuration, when decisions are made
import {fetchConfiguration, setDimmLevel, storeConfiguration} from '../slices/configurationSlice';
import {setProfileData} from '../slices/lightProfileSlice';
import {setSolarData} from '../solar/solarSlice';

export const dataStorageMiddleware = store => next => async action => {
    const result = next(action);

	// store
    if (action.type === 'decisions/decision/fulfilled' ||
		action.type === 'decisions/decisionsLoading/fulfilled' ||
		// action.type === 'status/setLang' ||
		// action.type === 'status/setRegion' ||
		action.type === 'status/duplicateConfiguration/fulfilled' ||

		action.type === 'lightProfile/fetchLightProfileLocation/fulfilled' ||
		action.type === 'lightProfile/setBaseProfileId' ||
		action.type === 'lightProfile/setZoneId' ||
		action.type === 'lightProfile/setCentralPowerControlId' ||
		action.type === 'lightProfile/setLuminaryId' ||

		action.type === 'solar/fetchSolarLocation/fulfilled' ||
		action.type === 'solar/setSolarUseCase' ||
		action.type === 'solar/setSolarShadowLevel' ||
		action.type === 'solar/setSolarActivityLevel' ||
		action.type === 'solar/setSolarAzimuth' ||
		action.type === 'solar/setSolarDimmProfile' ||
		action.type === 'solar/setSolarGenerators' ||
		action.type === 'solar/setSolarLuminarCount' ||
		action.type === 'solar/setSolarVersion' ||
		action.type === 'solar/setSolarTemperature' ||
		action.type === 'solar/setSolarBatteryType' ||
		action.type === 'solar/setSolarLumPosition1' ||
		action.type === 'solar/setSolarLumPosition2' ||
		action.type === 'solar/fetchPVGIS/fulfilled' ||

		action.type === 'lightProfile/setProjectName' ||
		action.type === 'lightProfile/setPicoPassword'

	) {
        // after decision(s), store the current state
		store.dispatch(storeConfiguration());
    }
	if (action.type === 'status/setKey') {
		// when a key is set, store to backend and fetch new configuration
		//await store.dispatch(storeConfiguration());
		//await store.dispatch(fetchConfiguration());
	}

	// load
	if (action.type === 'configuration/configurationLoading/fulfilled') {
		if (action.payload.data.projects[0].project.lightProfileData) {
			await store.dispatch(setProfileData(action.payload.data.projects[0].project.lightProfileData));
		}
		if (action.payload.data.projects[0].project.dimmLevelData) {
			await store.dispatch(setDimmLevel(action.payload.data.projects[0].project.dimmLevelData));
		}
		if (action.payload.data.projects[0].project.solarData) {
			await store.dispatch(setSolarData(action.payload.data.projects[0].project.solarData));
		}
	}
    return result;
};
